<div class="max-w-md mx-auto mt-12 p-8 bg-white rounded-2xl shadow-lg animate-fade-in space-y-6 relative">

    <div *ngIf="loading()" class="absolute inset-0 bg-white/60 backdrop-blur-sm z-10 flex items-center justify-center">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <h2 class="text-3xl font-bold text-center text-gray-700">Crear cuenta</h2>

    <app-social-login-buttons (success)="onLoginExitoso()"></app-social-login-buttons>


    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="first_name" required>
        <mat-error *ngIf="form.get('first_name')?.invalid && form.get('first_name')?.touched">
          Nombre es obligatorio
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Apellido</mat-label>
        <input matInput formControlName="last_name" required>
        <mat-error *ngIf="form.get('last_name')?.invalid && form.get('last_name')?.touched">
          Apellido es obligatorio
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" required>
        <mat-error *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
          Ingresá un email válido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Contraseña</mat-label>
        <input matInput type="password" formControlName="password" required>
        <mat-error *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
          Mínimo 6 caracteres
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Fecha de nacimiento</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="birthdate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker startView="multi-year"></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nacionalidad</mat-label>
        <mat-select formControlName="nationality">
          <mat-option *ngFor="let country of countries" [value]="country.id">
            <img [src]="'https://flagcdn.com/w40/' + country.id.toLowerCase() + '.png'" width="20" class="inline-block mr-2" />
            {{ country.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <re-captcha
        [siteKey]="recaptchaSiteKey"
        theme="dark"
        (resolved)="onRecaptchaResolved($event)"
        (error)="onRecaptchaError()">
      </re-captcha>

      <p *ngIf="recaptchaError()" class="text-red-600 text-sm mt-2">
        {{ recaptchaError() }}
      </p>

      <button
        mat-raised-button
        color="primary"
        class="w-full py-2 font-semibold tracking-wide"
        type="submit"
        [disabled]="form.invalid || loading() || !recaptchaResolved()"
      >
        Registrarse
      </button>

      <p *ngIf="error()" class="text-red-600 text-center text-sm mt-2">
        {{ error() }}
      </p>
    </form>
  </div>